/**
 * Expand selected locations into a deduplicated list of country ISO codes.
 * Handles plain country ISOs, custom group URL params, and standard group codes.
 *
 * @param {string[]} selectedLocations - Array of location codes from the URL
 * @param {Array<{iso: string, grps?: string[]}>} countryList - Countries with group memberships
 * @param {function} parseCustomGroupUrlParam - Parser for custom group URL params
 * @returns {string[]} Deduplicated array of country ISO codes
 */
export function expandLocationsToCountries(selectedLocations, countryList, parseCustomGroupUrlParam) {
  const allCountries = [];

  (selectedLocations || []).forEach((loc) => {
    // Check if it's a custom group URL param
    const customGroup = parseCustomGroupUrlParam(loc);
    if (customGroup && customGroup.countries) {
      allCountries.push(...customGroup.countries);
      return;
    }

    // Check if it's a standard group (countries have grps arrays containing group codes)
    const countriesInGroup = (countryList || []).filter((country) => country.grps && country.grps.includes(loc));
    if (countriesInGroup.length > 0) {
      allCountries.push(...countriesInGroup.map((c) => c.iso));
      return;
    }

    // Otherwise treat as a country ISO code
    if (/^[A-Z]{2,3}$/.test(loc)) {
      allCountries.push(loc);
    }
  });

  return [...new Set(allCountries)];
}
